import * as React from "react"; 
import Breadcrumbs from "../common/components/FDIC/Breadcrumbs";
import NoticeScreen from "../common/components/NoticeScreen";
import BankSearch from "../common/components/BankSearch";
import "../common/styles/App.css"; 

 

interface AppState {
    hasUserAccepted: boolean;
    userRole: string;
    isOpen: boolean;
}


class App extends React.Component<any, AppState> {  

    constructor(props: any) {
        super(props);

        this.state = {
            hasUserAccepted: false,
            userRole: "",
            isOpen: false,
     
        };
        this.handelUserAcceptance = this.handelUserAcceptance.bind(this);
     
    }

   
  


    componentDidMount() {
        document.title = "FDIC | Is My Account Fully Insured?";
    }
 
  
    handelUserAcceptance() {
        this.setState({
            hasUserAccepted: true
        });
    } 
  
          

    public render() { 
        <Breadcrumbs pageTitle="  " />; 
        let content = <NoticeScreen onAction={this.handelUserAcceptance} />;
        if (this.state.hasUserAccepted) {
            content = <BankSearch onAction={this.handelUserAcceptance}></BankSearch>; 
      
        }

        return (
            <div id="aiiApp">  
                <Breadcrumbs pageTitle=" Is My Account Fully Insured?" /> 
                <main id="content">
                    {content}
                </main>
       
                <div> 
                </div>
       
            </div>
     
        );
    }
} 
export default App;